import { TextareaAutosize, TextareaAutosizeProps } from '@mui/base/TextareaAutosize'
import React, { useState } from 'react'

import { FormFieldLabel } from './FormFieldLabel'
import { TextInput } from './TextInput'

interface TextAreaWithLabelProps extends TextareaAutosizeProps {
  label: string
}

export const TextAreaWithLabel = ({
  label,
  value,
  onChange,
  disabled,
  inputMode,
  placeholder,
  minRows,
  maxRows,
}: TextAreaWithLabelProps) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <>
      <FormFieldLabel shrink={isFocused || !!value}>{label}</FormFieldLabel>
      <TextInput
        label={label}
        maxRows={maxRows}
        minRows={minRows}
        placeholder={placeholder}
        inputMode={inputMode}
        disabled={disabled}
        onChange={onChange}
        value={value}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        data-test-id="text_area-with_label"
        inputComponent={TextareaAutosize}
        inputProps={{
          minRows,
          maxRows,
          style: { resize: 'vertical', minHeight: '1.5rem' },
        }}
      />
    </>
  )
}
